import { Component, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { VisaDetail, VisaError } from "src/app/model/employees";
import { AppService } from "src/app/services/app/app.service";
import { CommonService } from "src/app/services/common/common.service";
import { RecruiterService } from "src/app/services/recruiter/recruiter.service";


@Component({
  selector: "app-add-visa",
  templateUrl: "./add-visa.component.html",
  styleUrls: ["./add-visa.component.scss"],
})
export class AddVisaComponent {
  public addForm!: FormGroup;
  files: any[] = [];
  passportFiles: any[] = [];
  public error: VisaError = {
    visa: false,
    passport: false,
  };
  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    private dialogRef: MatDialogRef<AddVisaComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: VisaDetail,
    private commonService: CommonService,
    private recruiterService: RecruiterService
  ) { }

  ngOnInit(): void {
    this.addForm = this.fb.group({
      ex_dt: ["", Validators.required],
      permitted_hour: ["", Validators.required],
      notes: ["", Validators.required],
      passport_number: ["", Validators.required],
      nationality: ["", Validators.required],
      custom: [""]
      // visa:["",Validators.required],
      // pass_img:["",Validators.required]
    });
    this.onCustomHoursValidation()
    if (this.dialogData) {
      // this.addForm.get('ex_dt')?.setValue(this.dialogData.ex_dt)
      this.addForm.get('ex_dt')?.setValue(new Date(this.dialogData.ex_dt));
      this.addForm.get('nationality')?.setValue(this.dialogData.nationality);
      this.addForm.get('notes')?.setValue(this.dialogData.notes);
      this.addForm.get('passport_number')?.setValue(this.dialogData.passport_number)
      this.addForm.get('permitted_hour')?.setValue(this.dialogData.permitted_hour)
      this.passportFiles = this.dialogData.pass_img;
      this.files = this.dialogData.visa;
      this.passportFiles = this.passportFiles.map(item => {
        let image = item["pass_img"]
        let fileName = image.split('/').pop();
        let fileExtension = fileName?.split('.').pop();
        item["name"] = fileName;
        item["type"] = fileExtension
        return item
      })
      this.files = this.files.map(item => {
        let image = item["image"]
        let fileName = image.split('/').pop();
        let fileExtension = fileName?.split('.').pop();
        item["name"] = fileName;
        item["type"] = fileExtension
        return item
      })
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onCancel() {
    this.dialogRef.close();
  }
  onSubmit() {
    this.error.visa = this.error.passport = false;
    if (this.addForm.valid == false) {
      this.addForm.markAllAsTouched();
    } else if (this.files.length == 0) {
      this.error.visa = true;
    } else if (this.passportFiles.length == 0) {
      this.error.passport = true;
    } else {
      let newFormData = new FormData()
      newFormData.append('passport_number', this.addForm.get('passport_number')?.value)
      newFormData.append('ex_dt', this.addForm.get('ex_dt')?.value)
      newFormData.append('nationality', this.addForm.get('nationality')?.value)
      newFormData.append('notes', this.addForm.get('notes')?.value)
      newFormData.append('em_i', this.dialogData['em_i'])
      newFormData.append('t', '5')
      if (this.addForm.value.permitted_hour == 'custom') {
        newFormData.append('permitted_hour', this.addForm.get('custom')?.value)
      }
      else {
        newFormData.append('permitted_hour', this.addForm.get('permitted_hour')?.value)
      }
      for (let i = 0; i < this.passportFiles.length; i++) {
        if (this.passportFiles[i].hasOwnProperty('id')) { }
        else {
          newFormData.append('pass_img[]', this.passportFiles[i])
        }
      }
      for (let j = 0; j < this.files.length; j++) {
        if (this.files[j].hasOwnProperty('id')) { }
        else {
          newFormData.append('visa[]', this.files[j])
        }
      }
      this.recruiterService.submitVisa(newFormData).subscribe({
        next: (success: any) => {
          //this.spinner.hide()
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close();
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  onCustomHoursValidation() {
    this.addForm.get('permitted_hour')?.valueChanges.subscribe((value) => {
      if (value == 'custom') {
        this.addForm.get('custom')?.setValidators(Validators.required)
      }
      else {
        this.addForm.get('custom')?.clearValidators()
      }
      this.addForm.get('custom')?.updateValueAndValidity()
    })
  }
  onSelect(event, type) {
    if (type == "visa") {
      this.files.push(...event.addedFiles);
    } else {
      this.passportFiles.push(...event.addedFiles);
    }
  }

  onRemove(event, type) {
    if (type == "visa") {
      this.files.splice(this.files.indexOf(event), 1);
    } else {
      this.passportFiles.splice(this.files.indexOf(event), 1);
    }
  }
}
